import React, { useState } from 'react';

import { MenuItem } from '@mui/material';

import useUserHook from 'hooks/useUserHook';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import Icon from 'components/common/Icons/base/Icon/Icon';

import { CustomizedDropdownMenu, CustomizedRoundIcon, CustomizedTooltip } from 'components/common';
import { CopyQualitySettingsModal } from 'components/widgets/CopyQualitySettingsModal/copyQualitySettingsModal';

export const LogicQualityCheckActionsMenu = () => {
    const [isShowModalCopyQualitySettings, setIsShowModalCopyQualitySettings] = useState(false);
    const { ability } = useUserHook();
    if (!ability.can('view', 'LogicCheckerManager')) return null;
    return (
        <>
            <CustomizedDropdownMenu
                triggerElement={
                    <CustomizedTooltip
                        tooltipPosition={TooltipPosition.Top}
                        tooltipContent={`Manage Quality Settings`}
                        triggerElement={
                            <CustomizedRoundIcon>
                                <Icon name={'three-dot-icon'} />
                            </CustomizedRoundIcon>
                        }
                    />
                }
            >
                <MenuItem onClick={() => setIsShowModalCopyQualitySettings(true)}>Copy Quality Settings</MenuItem>
            </CustomizedDropdownMenu>
            <CopyQualitySettingsModal
                showModal={isShowModalCopyQualitySettings}
                onHideModal={() => setIsShowModalCopyQualitySettings(false)}
            />
        </>
    );
};
